export default "__VITE_ASSET__D8gOy7DL__"